import { useState } from "react";
import { useTranslation } from "react-i18next";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { LANGUAGES, switchLanguage } from "../../i18n/languages";

export function HeaderLanguage() {
  const { t, i18n } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <Tooltip title={t("header.language")} arrow>
        <button
          type="button"
          aria-haspopup="true"
          aria-label={t("header.language")}
          onClick={e => setAnchor(e.currentTarget)}
          className="flex items-center gap-1 transition duration-150 hover:text-theme-primary-contrast-hover cursor-pointer"
        >
          <FontAwesomeIcon icon={faGlobe} className="!w-5 !h-5 compact:!w-4 compact:!h-4" />
          <span className="text-xs font-semibold uppercase">{i18n.language.slice(0, 2)}</span>
        </button>
      </Tooltip>

      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <ul aria-label={t("header.language")} className="flex flex-col p-1 bg-theme-surface-2 border border-theme-border">
          {LANGUAGES.map(language => (
            <li key={language.code}>
              <button
                type="button"
                lang={language.code}
                aria-current={language.code === i18n.language ? "true" : undefined}
                onClick={() => {
                  setAnchor(null);
                  if (language.code !== i18n.language) switchLanguage(language.code);
                }}
                className={`w-full text-left px-3 py-1 text-sm rounded cursor-pointer hover:bg-theme-surface ${language.code === i18n.language ? "font-semibold text-theme-primary" : "text-theme-text"}`}
              >
                {language.name}
              </button>
            </li>
          ))}
        </ul>
      </Popover>
    </>
  );
}
